import { render } from "./DashboardAgent.vue?vue&type=template&id=7c49beec&scoped=true"
import script from "./DashboardAgent.vue?vue&type=script&lang=js"
export * from "./DashboardAgent.vue?vue&type=script&lang=js"

import "./DashboardAgent.vue?vue&type=style&index=0&id=7c49beec&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c49beec"]])

export default __exports__